<template>
    <v-runtime-template :template="AgbLinkTemplate" />
</template>

<script>
    import VRuntimeTemplate from "v-runtime-template";

    export default {
        props: {
            product: {
                type: String,
                required: true
            }
        },
        computed: {
            Strings() {
                return this.$migrolVueLibraryData.Strings;
            },
            Settings() {
                return this.$migrolVueLibraryData.Settings;
            },
            AgbLinkTemplate() {
                return this.Strings['Global.AGBDSE.AGBCheckbox'];
            },
            AgbLink() {
                switch (this.product) {
                    case 'Heizoel':
                        return this.Settings['agbHeizoel'];
                    case 'Diesel':
                        return this.Settings['agbDiesel'];
                    case 'Pellets':
                        return this.Settings['agbPellets'];
                    case 'Tankrevision':
                        return this.Settings['agbTankrevision'];
                    case 'Boilerentkalkung':
                        return this.Settings['agbBoilerentkalkung'];
                }
                return '';
            }
        },
        components: {
            VRuntimeTemplate
        }
    };
</script>